<div class="checkbox-cell-container" [class.edit-mode]="isEditMode" [class.view-mode]="!isEditMode">
  <div class="checkbox-wrapper">
    <mat-checkbox 
      [checked]="isChecked" 
      (change)="isChecked = $event.checked; onCheckboxChange()"
      [disabled]="isEditMode"
      [color]="'primary'"
      class="checkbox-input">
      <span class="checkbox-label">{{ labelText }}</span>
    </mat-checkbox>
  </div>
</div>